import React from 'react';
import { ui } from 'components';

import 'assets/screens.scss';
import './style.scss';

const ContactsScene = () => (
	<div className="contacts-layout">
    <h1 className="contacts-layout__caption">Контакты</h1>
    <article className="contacts-layout__text">Вы посетили официальный интернет-магазин <a className="contacts-layout__text__link" rel="noopener noreferrer" target="_blank" href="https://yartf.ru">Ярославской трикотажной фабрики</a></article>
    <article className="contacts-layout__text">Заказать термобелье в нашем интернет-магазине вы можете круглосуточно. После оформления заказа менеджер свяжется с вами в рабочее время для подтверждения заказа и уточнения деталей.</article>
    <article className="contacts-layout__text">Посетите наш магазин по адресу: г. Ярославль, ул. Полушкина роща, д. 5.</article>
    <div className="contacts-layout__info">
      <section className="contacts-layout__list">
        <div className="contacts-layout__block">
          <h3 className="contacts-layout__block__caption">Режим работы магазина</h3>
          <div className="contacts-layout__block__text">
            пн-пт: с 9:00 до 18:00
          </div>
        </div>
        <div className="contacts-layout__block">
          <h3 className="contacts-layout__block__caption">Адрес</h3>
          <div className="contacts-layout__block__text">
            150030, г. Ярославль,
          </div>
          <div className="contacts-layout__block__text">
            ул. Полушкина роща, д. 5
          </div>
        </div>
        <div className="contacts-layout__block">
          <h3 className="contacts-layout__block__caption">Телефоны</h3>
          <div className="contacts-layout__block__text">
            8 4852 58 16 45
          </div>
          {/*<div className="contacts-layout__block__text">*/}
            {/*8 910 971 55 59*/}
          {/*</div>*/}
        </div>
        <div className="contacts-layout__block">
          <h3 className="contacts-layout__block__caption">E-mail</h3>
          <div className="contacts-layout__block__text">
            order@yartf.ru
          </div>
        </div>
        <div className="contacts-layout__block">
          <h3 className="contacts-layout__block__caption">Оптовые закупки</h3>
          <div className="contacts-layout__block__text">
            <a className="contacts-layout__text__link" rel="noopener noreferrer" target="_blank" href="https://yartf.ru">yartf.ru</a>
          </div>
        </div>
      </section>
      <section className="contacts-layout__map">
        <ui.YandexMap
          center={{ lat: 57.645295, lon: 39.880891 }}
          marker={{ lat: 57.646244, lon: 39.879196 }}
          width={500}
          height={400}
          zoom={15}
        />
      </section>
    </div>
	</div>
);

export default ContactsScene;



// WEBPACK FOOTER //
// ./src/scenes/ContactsScene/index.js